import React, { useEffect, useRef, useState } from 'react';
import { ActivityIndicator, View, Animated, Platform } from 'react-native';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Focusable } from '../../Focusable';
import { Icon } from '../../Icon';
import { Text } from './Text';
export const Base = (props) => {
    const styles = useStyleSheet(getStyles);
    const [width, setWidth] = useState();
    const [measured, setMeasured] = useState(false);
    const { size } = useThemeContext();
    const animation = useRef();
    const container = useRef();
    const iconSize = React.useMemo(() => {
        switch (props.size) {
            case 'lg':
                return size.I;
            case 'md':
                return size.H;
            case 'sm':
                return size.G;
            case 'xs':
                return size.F;
        }
    }, [props.size]);
    const loadingIndicatorSize = React.useMemo(() => {
        switch (props.size) {
            case 'lg':
                return size.I;
            case 'md':
                return size.H;
            case 'sm':
                return size.G;
            case 'xs':
                return size.G;
        }
    }, [props.size]);
    const loadingIndicatorPadding = React.useMemo(() => {
        switch (props.size) {
            case 'lg':
                return size.F;
            case 'md':
                return size.E;
            case 'sm':
                return size.D;
            case 'xs':
                return 9;
        }
    }, [props.size]);
    useEffect(() => {
        if (measured || !container.current)
            return;
        container.current.measure((_, __, width) => {
            setWidth(width);
            animation.current = new Animated.Value(width);
            setMeasured(true);
        });
    }, [measured]);
    useEffect(() => {
        setMeasured(false);
    }, [props.text, props.size]);
    useEffect(() => {
        if (!animation.current || !width)
            return;
        Animated.timing(animation.current, {
            toValue: props.isLoading
                ? loadingIndicatorSize + 2 * loadingIndicatorPadding
                : width,
            duration: 250,
            useNativeDriver: Platform.OS !== 'web'
        }).start();
    }, [props.isLoading, width]);
    return (React.createElement(View, { style: [
            styles.wrapper,
            props.wrapperStyle,
            props.fluid ? styles.fluid : null,
            measured && width ? { width } : {}
        ] },
        React.createElement(Animated.View, { ref: container, style: [
                props.fluid ? styles.fluid : {},
                measured ? { width: animation.current } : {}
            ] },
            React.createElement(Focusable
            // @ts-expect-error react does not type ref forwarding properly at the moment
            , { 
                // @ts-expect-error react does not type ref forwarding properly at the moment
                ref: container, onPress: props.isLoading || props.disabled ? void 0 : props.onPress, hoverStyle: props.isLoading ? {} : props.hoverStyle, disabled: props.disabled, style: [
                    styles.container,
                    styles[`padding__${props.size}`],
                    props.style
                ] }, ({ hovered }) => (React.createElement(React.Fragment, null, props.isLoading ? (React.createElement(ActivityIndicator, { style: {
                    width: loadingIndicatorSize,
                    height: loadingIndicatorSize
                }, color: props.iconColor })) : (React.createElement(View, { style: [styles.main, styles[`main__${props.size}`]] },
                props.leftIcon && (React.createElement(View, { style: styles.leftIcon },
                    React.createElement(Icon, { size: iconSize, color: hovered ? props.iconHoverColor : props.iconColor, name: props.leftIcon }))),
                props.text && (React.createElement(Text, { size: props.size, numberOfLines: 1, selectable: false, fluid: !!(props.leftIcon && props.rightIcon), style: [
                        props.textStyle,
                        hovered ? props.textHoverStyle : {}
                    ] }, props.text)),
                props.rightIcon && (React.createElement(View, { style: styles.rightIcon },
                    React.createElement(Icon, { size: iconSize, color: hovered ? props.iconHoverColor : props.iconColor, name: props.rightIcon })))))))))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        borderRadius: 9999
    },
    wrapper: {
        alignItems: 'center'
    },
    main: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    main__lg: { paddingHorizontal: size.I },
    main__md: { paddingHorizontal: size.H },
    main__sm: { paddingHorizontal: size.G },
    main__xs: { paddingHorizontal: size.F },
    fluid: { width: '100%' },
    padding__lg: {
        paddingVertical: size.F
    },
    padding__md: {
        paddingVertical: size.E
    },
    padding__sm: {
        paddingVertical: size.D
    },
    padding__xs: {
        paddingVertical: 9
    },
    loading: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    rightIcon: { marginLeft: size.B },
    leftIcon: { marginRight: size.B }
}));
//# sourceMappingURL=Base.js.map